'use client'

import { cn } from '@src/utils/tailwind'

interface SkeletonProps {
  children?: React.ReactNode
  className?: string
}

export function SkeletonWrapper({ children, className }: SkeletonProps) {
  return <div className={cn('animate-pulse', className)}>{children}</div>
}

export function SkeletonBlock({ children = null, className }: SkeletonProps) {
  return (
    <div className={cn('inline-block rounded-md bg-gray-200 dark:bg-bodi-gray-light', className)}>
      <div className="inline-block opacity-0">{children}</div>
    </div>
  )
}

export function SkeletonText({ text = '' }: { text: string } & Pick<SkeletonProps, 'className'>) {
  return (
    <Skeleton.Wrapper>
      {text.split(' ').map((word, index) => (
        <Skeleton.Block key={`${word}-${index}`} className="scale-x-105 scale-y-75 rounded-none">
          {word}
        </Skeleton.Block>
      ))}
    </Skeleton.Wrapper>
  )
}

export const Skeleton = {
  Wrapper: SkeletonWrapper,
  Block: SkeletonBlock,
  Text: SkeletonText,
}
